module.exports = __webpack_public_path__ + "img/bb_g3_t_nose-01.94a41e8c.svg";